import type { ReactNode } from 'react'
import { useContext } from 'react'
import { useHereLocation, useMarker } from '../hooks'
import { HereMapContext } from './HereMap'

type MapMarkerProps = {
  position: {
    latitude: number
    longitude: number
  }
  children: ReactNode
  className?: string
}

/**
 * MapMarker puts its children on the map at a specific location.
 * It should be used as a direct child of the `HereMap` component.
 * @param position The location of the marker.
 * @param children The actual UI that should be shown.
 */
export const MapMarker = (props: MapMarkerProps) => {
  const { map } = useContext(HereMapContext)
  const position = useHereLocation(props.position)
  const markerRef = useMarker<HTMLDivElement>({ map, position })

  return (
    <div
      ref={markerRef}
      className={props.className}
      // This z-index prevents the marker from showing up twice on the map.
      css={{ zIndex: -1 }}
    >
      {props.children}
    </div>
  )
}
